// Copyright (c) 2017 Comsearch, Inc., All rights reserved

// NOTE: this does not return a <label>. This component is to be used with LabeledInput
// and in that rendering this component will be wrapped in the <label>. This component
// it reduces repetition when giving labels a ? 'tooltip'.

import React from 'react'
import { string } from 'prop-types'

const InfoLabel = ({ label, iconClasses, info }) => (
  <span className={'display-flex align-items-center'}>
    {label}
    <span
      className={`fa fa-question-circle margin-left-1 cursor-help ${iconClasses || ''}`}
      title={info} />
  </span>
)

InfoLabel.propTypes = {
  label: string.isRequired,
  iconClasses: string,
  info: string.isRequired,
}

export default InfoLabel
